/* import __COLOCATED_TEMPLATE__ from './select.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { SUPPORT } from 'sh-www/constants/links';
import clsx from 'clsx';

const CLASS_NAME = 'GLM-c-posting-badges-select';

class PostingBadgesSelectComponent extends Component {
  @service session;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get tooltip() {
    const { enableTooltip = true } = this.args;

    if (!enableTooltip) {
      return null;
    }

    const helpLink = this.session.currentUser?.isBuyer
      ? SUPPORT.SELECT_FOR_BUYERS
      : SUPPORT.SELECT_FOR_SELLERS;

    return `This is a Select project. <a href="${helpLink}" target="_blank">Learn more</a>`;
  }
}

export default PostingBadgesSelectComponent;
